"use strict";

var _classCallCheck = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createDisposable_1 = require("./createDisposable");

var DisposableCollection = /*#__PURE__*/function () {
  function DisposableCollection() {
    _classCallCheck(this, DisposableCollection);

    this.disposables = [];
  }

  _createClass(DisposableCollection, [{
    key: "dispose",
    value: function dispose() {
      if (this.disposed) return;

      while (!this.disposed) {
        this.disposables.pop().dispose();
      }
    }
  }, {
    key: "push",
    value: function push(disposable) {
      var _this = this;

      this.disposables.push(disposable);
      var originalDispose = disposable.dispose.bind(disposable);
      var toRemove = createDisposable_1.createDisposable(function () {
        var index = _this.disposables.indexOf(disposable);

        if (index !== -1) {
          _this.disposables.splice(index, 1);
        }
      });

      disposable.dispose = function () {
        toRemove.dispose();
        originalDispose();
      };

      return toRemove;
    }
  }, {
    key: "pushAll",
    value: function pushAll(disposables) {
      var _this2 = this;

      return disposables.map(function (disposable) {
        return _this2.push(disposable);
      });
    }
  }, {
    key: "disposed",
    get: function get() {
      return this.disposables.length === 0;
    }
  }]);

  return DisposableCollection;
}();

exports.DisposableCollection = DisposableCollection;